// extracted by mini-css-extract-plugin
export default {"root":"_38kGe","reaction":"_3HpVr","reaction-icon":"Oltw7","reactionIcon":"Oltw7"};